module.exports = __webpack_public_path__ + "assets/decline.5b3123686c77c179b27ef6d0763496c1.svg";